import {
  AutofillEncounterFromNotesArgs,
  AutofillEncounterFromNotesResponse,
  GetIcdCodeSuggestionsArgs,
  GetIcdCodeSuggestionsResponse,
  GetPregnancyClinicalRationaleArgs,
  GetPregnancyClinicalRationaleResponse,
} from '@hb/shared'
import { httpsCallable } from 'firebase/functions'
import { functions } from './functions'

export const autofillEncounterFromNotes = httpsCallable<
  AutofillEncounterFromNotesArgs,
  AutofillEncounterFromNotesResponse
>(functions, 'autofillEncounterFromNotes')

export const getIcdCodeSuggestions = httpsCallable<
  GetIcdCodeSuggestionsArgs,
  GetIcdCodeSuggestionsResponse
>(functions, 'getIcdCodeSuggestions')

export const getPregnancyClinicalRationale = httpsCallable<
  GetPregnancyClinicalRationaleArgs,
  GetPregnancyClinicalRationaleResponse
>(functions, 'getPregnancyClinicalRationale')

export const listModels = httpsCallable<{ filter?: string }>(functions, 'listModels')
